import { useEffect, useRef } from 'react';

/** Load the supplied Vidalytics player immediately when the hero mounts. */
export const VslHeroVideo = () => {
  const embedStarted = useRef(false);
  useEffect(() => {
    if (embedStarted.current) return;
    embedStarted.current = true;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function (v, i, d, a, l, y, t, c, s) {
        y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
        if (!vsl){vsl=function(u,cb){
          if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
          if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
          i.getElementsByTagName("head")[0].appendChild(s);
        };}
        vsl(l+'loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript(l+'player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
      })(window, document, 'Vidalytics', 'vidalytics_embed_nVUyb4nhDZzhsOJM', 'https://fast.vidalytics.com/embeds/Mm5pW7Mp/nVUyb4nhDZzhsOJM/');
    `;
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return (
    <div className="vsl-hero-video relative aspect-video w-full bg-primary/10">
      <div
        id="vidalytics_embed_nVUyb4nhDZzhsOJM"
        aria-label="The Winning Reels Blueprint® — video"
        className="relative w-full pt-[56.25%]"
      />
    </div>
  );
};


